import React from 'react';
import { useCompactMode } from '../context/CompactModeContext';
import { useNavigate } from "react-router-dom";
import "../styles/SettingsPage.css";
import ThemeSelector from '../context/ThemeSelector'; // ✅ Import the selector
import {
  Settings as SettingsIcon,
  Bell,
  Eye,
  Lock,
  ShieldCheck,
  Server,
  CreditCard,
  User,
  Globe,
  Users
} from 'lucide-react';

const SettingsPage = () => {
  const { compactMode, toggleCompactMode } = useCompactMode();

  const navigate = useNavigate();

  return (
    <div className="settings-page">
      <header className="header">
        <h1>
          <SettingsIcon size={28} style={{ marginRight: '10px', verticalAlign: 'middle' }} />
          Settings
        </h1>
        <p style={{ color: 'var(--text-secondary)' }}>
          Manage system preferences and account configurations. Update account preferences,
          notifications, security, and center settings.
        </p>
      </header>

      <section className="card-grid">

        {/* Cards */}
        <div
          className="card settings-card"
          onClick={() => navigate("/settings/notifications")}
          style={{ cursor: "pointer" }}
        >
          <div className="card-icon">
            <Bell size={22} />
          </div>

          <div className="card-content">
            <h3>Notification Preferences</h3>
            <p>
              Choose which alerts, reminders, and message updates you want to receive.
            </p>
            <span className="badge info">Enabled</span>
          </div>
        </div>

        <div className="card settings-card">
          <div className="card-icon"><User size={22} /></div>
          <div className="card-content">
            <h3>Account Info</h3>
            <p>Edit email, password, and contact details</p>
            <span className="badge warning">Needs Review</span>
          </div>
        </div>

        <div className="card settings-card">
          <div className="card-icon"><Eye size={22} /></div>
          <div className="card-content">
            <h3>Display</h3>
            <p>Theme, layout, and accessibility settings</p>
            <span className="badge success">Default</span>
          </div>
        </div>

        <div className="card settings-card">
          <div className="card-icon"><Globe size={22} /></div>
          <div className="card-content">
            <h3>Preferences</h3>
            <p>Change language, theme, and notification options</p>
            <span className="badge info">Synced</span>
          </div>
        </div>

        <div className="card settings-card">
          <div className="card-icon"><Users size={22} /></div>
          <div className="card-content">
            <h3>Center Info</h3>
            <p>Update name, address, hours, classes, and logo</p>
            <span className="badge warning">Incomplete</span>
          </div>
        </div>

        <div className="card settings-card">
          <div className="card-icon"><Lock size={22} /></div>
          <div className="card-content">
            <h3>Security</h3>
            <p>Update passwords, 2FA, device access, review login history, and roles</p>
            <span className="badge warning">Action Required</span>
          </div>
        </div>

        <div className="card settings-card">
          <div className="card-icon"><ShieldCheck size={22} /></div>
          <div className="card-content">
            <h3>Compliance Settings</h3>
            <p>Privacy, data retention, and audit policies</p>
            <span className="badge success">Compliant</span>
          </div>
        </div>

        <div className="card settings-card">
          <div className="card-icon"><Server size={22} /></div>
          <div className="card-content">
            <h3>Integrations</h3>
            <p>Connected services</p>
            <span className="badge info">3 Linked</span>
          </div>
        </div>

        <div className="card settings-card">
          <div className="card-icon"><CreditCard size={22} /></div>
          <div className="card-content">
            <h3>Billing</h3>
            <p>Manage subscriptions and payments</p>
            <span className="badge success">Active</span>
          </div>
        </div>

        <div className="card settings-card">
          <div className="card-icon"><ShieldCheck size={22} /></div>
          <div className="card-content">
            <h3>Privacy</h3>
            <p>Control who can view or edit records</p>
            <span className="badge success">Secure</span>
          </div>
        </div>
      </section>

      <div
        className="settings-card"
        onClick={() => navigate("/settings/centers")}
        style={{ cursor: "pointer" }}
      >
        <h3>Centers</h3>
        <p>Open center management to deactivate locations or review center availability.</p>
        <span className="badge info">Organization</span>
      </div>

      {/* Theme Selector Section */}
      <section className="settings-theme-section" style={{ marginTop: '40px' }}>
        <h2 style={{ marginBottom: '12px' }}>Theme Preferences</h2>
        <ThemeSelector />
      </section>

      {/* Compact Mode Toggle */}
      <section className="settings-compact-section">
        <h2 style={{ marginBottom: '12px' }}>Layout Options</h2>
        <div className="settings-toggle">
          <label htmlFor="compactToggle">Compact Mode</label>
          <input
            type="checkbox"
            id="compactToggle"
            checked={compactMode}
            onChange={toggleCompactMode}
          />
        </div>
      </section>
    </div>
  );
};

export default SettingsPage;
